import { object, string, array, number, SchemaOf, boolean } from 'yup';

import { DockerSecurityFormValues } from './types';

export const dockerSecurityValidationSchema: SchemaOf<DockerSecurityFormValues> =
  object({
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),
    allowBindMountsForRegularUsers: boolean().required(),
    allowPrivilegedModeForRegularUsers: boolean().required(),
    allowHostNamespaceForRegularUsers: boolean().required(),
    allowDeviceMappingForRegularUsers: boolean().required(),
    allowStackManagementForRegularUsers: boolean().required(),
    allowContainerCapabilitiesForRegularUsers: boolean().required(),
    allowSysctlSettingForRegularUsers: boolean().required(),
  });
